import { Button } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OnboardingPage = ({ history }) => {
  const handleLoadDemoData = () => {
    // Set a default demo shop ID to avoid undefined errors in downstream API calls.
    const demoShopId = 'demo-shop-123';
    localStorage.setItem('shopId', demoShopId);
    console.log(`Demo data loaded with shopId: ${demoShopId}`);

    // Navigate to the dashboard (adjust the route as needed).
    if (history && typeof history.push === 'function') {
      history.push('/dashboard');
    }
  };

  return (
    <Container>
      <Button type="primary" onClick={handleLoadDemoData}>
        Load Demo Data
      </Button>
    </Container>
  );
};

export default OnboardingPage;
